module.exports = __webpack_public_path__ + "static/media/icon-yellowTriangleP.da705007.svg";